__turbopack_context__.v({
  "root": "PlasmicCarouselBtn-module__tOZIua__root",
  "root___focusWithin__focusVisibleWithin": "PlasmicCarouselBtn-module__tOZIua__root___focusWithin__focusVisibleWithin",
  "rootback": "PlasmicCarouselBtn-module__tOZIua__rootback",
  "svg": "PlasmicCarouselBtn-module__tOZIua__svg",
  "svgback": "PlasmicCarouselBtn-module__tOZIua__svgback",
});
